import React, { Component } from 'react'

import api from '../../services';

import { Link } from 'react-router-dom';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'moment/locale/pt-br'; 

import Header from '../../includes/Header';
import Sidemenu from '../../includes/Sidemenu';
import Loading from '../../components/Loading';

toast.configure();

export default class GrupousuarioForm extends Component{
    constructor(props){
        super(props);

        this.state = {
            visibleModal: false,
            isLoading: true,
            popoverOpenImg: false,
            submittedForm: false,
            formError: false,
            tooltip2: '',

            cd_grupousuario: '', 
            ds_grupousuario: '', 
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
        event.preventDefault();
        
        const target = event.target;
        const name = target.name;
        var value2 = target.type === 'checkbox' ? target.checked : target.value;
        
        this.setState({
            [name]: value2
        });
    }

    componentWillMount(){

        const par = this.props.match.params;
        
        if (par.id !== undefined) {
            this.setState({
                cd_grupousuario: par.id
            }, () => {
                this.consultaAPI();
            });
        } else {
            this.consultaAPI();
        }
    }

    consultaAPI = async(act) => {
        
        /* Função padrão para popular objetos na tela */
        /* Todas as consultas são feitas de uma vez e depois os dados são manipulados */
        /* Para toda consulta em API usar Try Catch para evitar Crashs no APP */
    
        try { 

            this.setState({ isLoading: true });

            if( act === undefined ){
                var response = await api.get(`/grupousuario/${this.state.cd_grupousuario}`);
            } else {
                var response = null;
            }
            
            Promise.all([
                response,
            ]).then((values) => {
                
                this.setState({ 
                    isLoading: false,
                })

                let promisse1 = values[0];
                /**
                 * Segunda Promisse - Combo Tipo usuario
                */
                if (promisse1 !== undefined && promisse1.data !== null) {
                
                    let dados = promisse1.data.data;
                    
                    this.setState({  
                        cd_grupousuario: dados.cd_grupousuario || '',  
                        ds_grupousuario: dados.ds_grupousuario || '', 
                    }, () => {
                        console.log('state ',this.state)
                    });
                } 
            });
        
        } catch (response) { 
            console.log(response)
            this.setState({ isLoading: false, tooltip2: "Houve um erro"});
        }
    }

    validation = () => {
        const { ds_grupousuario } = this.state;
        
        if (ds_grupousuario === '') {
            return false;
        } else {
            return true;
        }
    }

    /**
     * Função padrão para envio de Formulário
     */
    handleSubmit = async (event) => {
        event.preventDefault();

        this.setState({ 
            submittedForm: true, 
        });
        
        if (!this.validation()) {
            return false;
        }
        /* Função padrão para popular objetos na tela */
        /* Todas as consultas são feitas de uma vez e depois os dados são manipulados */
        /* Para toda consulta em API usar Try Catch para evitar Crashs no APP */
        
        try { 
            console.log(this.state)
            if( this.state.cd_grupousuario != '' ){
                var response = await api.put(`/grupousuario/${this.state.cd_grupousuario}`,this.state);
            } else {
                var response = await api.post(`/grupousuario/`,this.state);
            }

            console.log(response)
            
            if( response.data.errors === "" ){    
                if (this.state.cd_grupousuario != '') {
                    toast.success('Grupo editado com sucesso!', { autoClose: 3000, toastId: 1 });
                } else {
                    toast.success('Grupo cadastrado com sucesso!', { autoClose: 3000, toastId: 1 });
                }

                this.voltar();

            }  else {
                toast.error('Houve um erro, tente novamente mais tarde', { autoClose: 3000, toastId: 1 });
            }
            
        } catch (resp) { 
            console.log(resp)
            this.setState({ isLoading: false, tooltip2: "Houve um erro"});
        }
    }
    
    requiredField = () => {
        return (
            <div className="requiredField">* Campo requerido</div>
        )
    }

    voltar = () => {
        this.props.history.push('/grupousuario');
    }

    render(){
        const { submittedForm, isLoading } = this.state;
        
        return (
            <div style={{ width:'100%' }}>
                <Sidemenu />
                <Loading isLoading={isLoading} />
                <main className="admin-main">
                    <Header />
                    <div className="bg-gray-400">
                        <div className="container  m-b-30">
                            <div className="row">
                                <div className="col-12 p-t-20 p-b-70">
                                    <div className="media">
                                        <div className="avatar avatar mr-3">
                                            <div className="avatar-title bg-gray-600 rounded-circle icon-placeholder mdi mdi-account-group"></div>
                                        </div>
                                        <div className="media-body">
                                            <h2>{ this.state.cd_grupousuario === '' ? 'Novo Grupo de Usuário' : 'Grupos de Usuários'}</h2>
                                        </div>
                                        
                                        <div className="float-right">
                                            <Link to={`/grupousuario/form/`} className="btn-primary btn btn-md m-b-15 ml-2 mr-2">
                                                <i className="mdi mdi-plus"></i> Novo Grupo de Usuário
                                            </Link>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container  pull-up">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body">
                                        <form onSubmit={this.handleSubmit} className="formGeral m-t-30">
                                            <div className="form-row" >
                                                <div className="form-group col-md-12">
                                                    <label htmlFor="ds_grupousuario">Descrição:</label>
                                                    <input 
                                                        type="text" 
                                                        name="ds_grupousuario" 
                                                        className="form-control"
                                                        value={this.state.ds_grupousuario}
                                                        onChange={this.handleInputChange} 
                                                    />
                                                    { submittedForm && this.state.ds_grupousuario === '' && this.requiredField()}
                                                </div>
                                            </div>
                                            <div className="form-group float-left">
                                                <div onClick={this.voltar} className="btn-outline-primary btn" style={{ cursor: 'pointer' }}>
                                                Voltar
                                                </div>
                                            </div>
                                            <div className="form-group float-right">
                                                <button type="submit" className="btn btn-primary">Salvar</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        )
    }
}